export default __webpack_public_path__ + "static/media/File No. 5.64f36234.pdf";